// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1_Rhh","buttons":"Footer_buttons__3WXRE"};